// Default quiz length. Some quiz routes opt into EXTENDED_TOTAL_ROUNDS explicitly.
export const TOTAL_ROUNDS = 3;
export const EXTENDED_TOTAL_ROUNDS = 5;
export const MAP_WIDTH = 760;
export const MAP_HEIGHT = 460;
export const MAP_PADDING = 24;
export const MAX_BLIND_MAP_DISTANCE_KM = 250;
